SharedMdl.service('UtilsSrv', [function(){
	// left: 37, up: 38, right: 39, down: 40,
	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	var scroll_keys = {37: 1, 38: 1, 39: 1, 40: 1};
	function fansPreventDefault(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	}



	return {

		/**
		 * Gets an object from a giving array by slug
		 * @param Array filterArr
		 * @param String currentFilterName
		 * @returns {Object}
		 */
		getFilterObj: function( filterArr, filterSlug ) {
			var filterObj = filterArr.filter(function( value ){
				return value.slug == filterSlug;
			})[0];

			return filterObj;
		},




		isArray: function( someVar ) {
			return Object.prototype.toString.call( someVar ) === '[object Array]'
		},

		scrollHandler: {
			preventDefaultForScrollKeys: function( e ) {
				if (scroll_keys[e.keyCode]) {
					fansPreventDefault(e);
					return false;
				}
			},

			disableScroll: function () {
				if (window.addEventListener) // older FF
					window.addEventListener('DOMMouseScroll', fansPreventDefault, false);
				window.onwheel = fansPreventDefault; // modern standard
				window.onmousewheel = document.onmousewheel = fansPreventDefault; // older browsers, IE
				window.ontouchmove  = fansPreventDefault; // mobile
				document.onkeydown  = this.preventDefaultForScrollKeys;
			},

			enableScroll: function() {
				if (window.removeEventListener)
					window.removeEventListener('DOMMouseScroll', fansPreventDefault, false);
				window.onmousewheel = document.onmousewheel = null;
				window.onwheel = null;
				window.ontouchmove = null;
				document.onkeydown = null;
			},

			scrollToFans: function() {
				var self = this,
				$fans = angular.element( document.querySelector('.the-fans .container') );

				this.disableScroll();

				$('html, body').animate({ scrollTop: $fans.offset().top }, 800, function(){
					self.enableScroll();
				});
			}

		}
	}
}]);
